import { ContainerComponent, wrap } from 'AppReact';
import {
  FitRelativeWrapper, CustomBackgroundWrapper, Mr2,
  AbsoluteLeftTopWrapper, CustomBorderWrapper, Mt2, GenericWrapper, Mr1,
  Mt4, Mt3, FlexCenterWrapper, FlexCenterJustifyCenterWrapper, Mt1, WhiteSpaceNoWrap, FullWIdthColumnScrollWrapper,
  CursorPointerWrapper, CustomHeight, PopupWrapper, ElementWithPopupWrapper
} from 'wrappers';
import {
  WhiteTextXs, Empty, CustomText, SecondaryTextBaseBold, SecondaryTextSm400
} from 'atoms';
import { SolidButton, OutlinedButton, ResidentNotifiedText } from 'molecules';
import Controller from './controller';
import internalState from './internalState';
import { format } from 'date-fns';
import { DefaultLabelIconSvg, EnvelopSvg } from 'components/icons';
import React from 'react';
import { getIsMobile } from 'utils';

const isMobile = getIsMobile();

const containerRef = React.createRef();

export const definition = {
  name: 'ResidentApprovalWrapper',
  controller: Controller,
  initialProps: ({ inspection, short }) => ({ inspection, short }),
  props: internalState,
  elements: [
    {
      wrapper: FitRelativeWrapper,
      name: 'Wrapper',
      elements: [
        {
          wrapper: wrap(CustomBackgroundWrapper, CursorPointerWrapper),
          name: 'NotApproved',
          renderIf: ({ inspection }) => inspection.is_approved === false,
          isButton: true,
          bindings: ({ inspection, isOpen }) => ({ inspection, isOpen, containerRef }),
          displayState: ({ isOpen }) => ({ background: !isMobile ? isOpen ? '#FFF1BF' : '#FFF9EC' : "transparent", alignItems: 'center', padding: !isMobile ? '8px 12px' : '', borderRadius: '22px' }),
          elements: [
            {
              component: isMobile ? wrap(Empty, Mr1) : wrap(Empty, Mr2),
              name: 'Icon',
              displayValue: ({ }) => EnvelopSvg({ width: isMobile ? 14 : 20, height: isMobile ? 12 : 18, color: '#FFC700', colored: true })
            },
            {
              component: wrap(CustomText, Mr1),
              name: 'Text',
              displayState: ({ isOpen, short }) => ({ color: isMobile ? '#FFC700' : '#970', fontSize: '14px', textDecoration: isOpen && isMobile && short ? 'underline' : 'none' }),
              displayValue: ({ short }) => short ? 'Pending' : 'Pending resident approval'
            },
            {
              component: CustomText,
              name: 'Remind',
              renderIf: ({ short }) => !short,
              displayState: ({ }) => ({ color: '#970', fontSize: '14px', textDecoration: 'underline', cursor: 'pointer' }),
              displayValue: ({ }) => 'Remind'
            },
          ]
        },
        {
          wrapper: ElementWithPopupWrapper,
          name: 'Approved',
          renderIf: ({ inspection }) => inspection.is_approved === true,
          elements: [
            {
              wrapper: CustomBackgroundWrapper,
              name: 'ApprovedWrapper',
              displayState: ({ }) => ({ background: !isMobile ? '#E8F8F0' : 'transparent', alignItems: 'center', padding: isMobile ? '4px 8px' : '8px 12px', borderRadius: '22px' }),
              elements: [
                {
                  component: isMobile ? Empty : wrap(Empty, Mr2),
                  name: 'Icon',
                  displayValue: ({ }) => DefaultLabelIconSvg({ width: isMobile ? 18 : 20, height: isMobile ? 18 : 20, color: '#1AAA60' })
                },
                {
                  component: CustomText,
                  name: 'Text',
                  displayState: ({ }) => ({ color: '#1AAA60', fontSize: '14px' }),
                  displayValue: ({ inspection }) => isMobile ? `${format(new Date(inspection.completion_date), 'dd MMM yyyy')}` : 'Approved by resident'
                }
              ]
            },
            {
              wrapper: PopupWrapper,
              name: 'PopupWrapper',
              displayState: ({ }) => ({ position: 'bottom', maxWidth: '400px', width: 'unset', topTransform: '30px', bottomTransform: '-45px', background: window?.settings?.secondary_color, }),
              elements: [
                {
                  component: wrap(WhiteTextXs, WhiteSpaceNoWrap),
                  name: 'By',
                  displayValue: ({ inspection }) => `By ${inspection.approved_event_created_by} on ${inspection?.approved_event_datetime ? format(new Date(inspection.approved_event_datetime), 'MM/dd/yyyy hh:mm a') : ''}`
                },
                {
                  wrapper: FlexCenterJustifyCenterWrapper,
                  name: '__transparent__',
                  elements: [
                    {
                      component: wrap(WhiteTextXs, Mr2),
                      name: 'Ip',
                      displayValue: ({ inspection }) => `${inspection?.approved_event_ip_address ? `IP Address: ${inspection.approved_event_ip_address}` : ''}`
                    },
                    {
                      wrapper: CursorPointerWrapper,
                      name: 'Button',
                      isButton: true,
                      bindings: ({ inspection }) => ({ inspection }),
                      elements: [
                        {
                          component: CustomText,
                          name: 'Copy',
                          displayState: ({ }) => ({ fontSize: '12px', color: '#FFFFFF', textDecoration: 'underline' }),
                          displayValue: ({ }) => `Copy`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
          ]
        },
        {
          wrapper: AbsoluteLeftTopWrapper,
          displayState: ({ }) => ({ top: isMobile ? '20px' : '40px', width: isMobile ? '300px' : '240px', left: isMobile ? '0px' : '20px', bottom: '5px' }),
          renderIf: ({ isOpen }) => isOpen,
          ref: containerRef,
          name: 'DropdownWrapper',
          elements: [
            {
              wrapper: CustomBorderWrapper,
              name: 'BorderWrapper',
              displayState: ({ }) => ({ borderRadius: '8px', padding: '16px', border: '1px solid #E3E3E3', background: '#FFFFFF' }),
              elements: [
                {
                  component: SecondaryTextBaseBold,
                  name: 'Title',
                  displayValue: ({ }) => 'Send a reminder?'
                },
                {
                  wrapper: CustomHeight,
                  name: 'CustomHeight',
                  displayState: ({ }) => ({ maxHeight: 150, display: 'flex', width: '100%' }),
                  elements: [
                    {
                      wrapper: FullWIdthColumnScrollWrapper,
                      name: '__transparent__',
                      displayState: ({ }) => ({ height: 'unset', flexGrow: 1 }),
                      renderIf: ({ inspection }) => inspection.reminders_sent_at && inspection.reminders_sent_at.length > 0,
                      elements: [
                        {
                          wrapper: isMobile ? wrap(FlexCenterWrapper, Mt2) : GenericWrapper,
                          name: 'Wrapper',
                          isListOf: { reminder: ({ inspection }) => inspection.reminders_sent_at },
                          displayState: ({ }) => ({ padding: '5px 0px 5px 0px' }),
                          elements: [
                            {
                              component: isMobile ? wrap(wrap(SecondaryTextSm400, WhiteSpaceNoWrap), Mr2) : wrap(SecondaryTextSm400, Mt3),
                              name: 'Text',
                              displayValue: ({ }) => 'Email sent'
                            },
                            {
                              component: isMobile ? wrap(SecondaryTextSm400, WhiteSpaceNoWrap) : wrap(SecondaryTextSm400, Mt1),
                              name: 'Text',
                              displayValue: ({ reminder }) => reminder ? format(new Date(reminder), 'MM/dd/yyyy hh:mm a') : ''
                            }
                          ]
                        },
                      ]
                    }
                  ]
                },
                {
                  wrapper: isMobile ? wrap(GenericWrapper, Mt4) : wrap(FlexCenterWrapper, Mt4),
                  name: 'Buttons',
                  elements: [
                    {
                      component: SolidButton,
                      name: 'Send',
                      renderIf: ({ }) => isMobile,
                      displayValue: () => null,
                      bindings: ({ }) => ({ title: 'Send', centeredLabel: true }),
                    },
                    {
                      component: isMobile ? wrap(OutlinedButton, Mt2) : wrap(OutlinedButton, Mr2),
                      name: 'Leave',
                      displayState: ({ }) => ({ justifyContent: 'center', big: true }),
                      bindings: ({ }) => ({ title: 'Cancel' })
                    },
                    {
                      component: SolidButton,
                      renderIf: ({ }) => !isMobile,
                      name: 'Send',
                      bindings: ({ }) => ({ title: 'Send', centeredLabel: true }),
                      displayState: ({ }) => ({ title: 'Send', centeredLabel: true })
                    }
                  ]
                },
                {
                  component: wrap(wrap(ResidentNotifiedText, Mt3), FlexCenterJustifyCenterWrapper),
                  name: 'ResidentNotifiedText',
                  bindings: ({ }) => ({})
                },
              ]
            }
          ]
        }
      ]
    }
  ]
};

export default ContainerComponent(definition);